import { useEffect, useState } from 'react';

export function useIntersectById(
  id: string,
  options: IntersectionObserverInit = { threshold: 0.1 }
) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const target = document.getElementById(id);
    if (!target) return;

    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting);
    }, options);

    observer.observe(target);

    return () => observer.disconnect();
  }, [id, options]);

  return isIntersecting;
}
